export default __webpack_public_path__ + "static/media/main-door.62bbd877.png";